export const TTX_SCENARIO_INDUSTRIES = {
  'Energy & Utilities': [
    {
      id: 'oil_gas',
      isDisabled: false,
      label: 'Oil & Gas',
      value: 'oil_gas',
    },
    {
      id: 'power_generation',
      isDisabled: false,
      label: 'Power Generation',
      value: 'power_generation',
    },
    {
      id: 'transmission_distribution',
      isDisabled: false,
      label: 'Transmission & Distribution',
      value: 'transmission_distribution',
    },
    {
      id: 'renewable_energy',
      isDisabled: false,
      label: 'Renewable Energy',
      value: 'renewable_energy',
    },
    {
      id: 'water_utilities',
      isDisabled: false,
      label: 'Water Utilities',
      value: 'water_utilities',
    },
    {
      id: 'waste_management',
      isDisabled: false,
      label: 'Waste Management',
      value: 'waste_management',
    },
  ],
  'Transportation & Logistics': [
    {
      id: 'aviation',
      isDisabled: false,
      label: 'Aviation',
      value: 'aviation',
    },
    {
      id: 'maritime',
      isDisabled: false,
      label: 'Maritime',
      value: 'maritime',
    },
    {
      id: 'rail',
      isDisabled: false,
      label: 'Rail',
      value: 'rail',
    },
    {
      id: 'road_transport',
      isDisabled: false,
      label: 'Road Transport',
      value: 'road_transport',
    },
    {
      id: 'logistics_supply_chain',
      isDisabled: false,
      label: 'Logistics & Supply Chain',
      value: 'logistics_supply_chain',
    },
    {
      id: 'public_transport',
      isDisabled: false,
      label: 'Public Transport',
      value: 'public_transport',
    },
  ],
  'Communications & Technology': [
    {
      id: 'telecommunications',
      isDisabled: false,
      label: 'Telecommunications',
      value: 'telecommunications',
    },
    {
      id: 'it_services_managed_providers',
      isDisabled: false,
      label: 'IT Services & Managed Providers',
      value: 'it_services_managed_providers',
    },
    {
      id: 'mssp',
      isDisabled: false,
      label: 'Managed Security Service Provider (MSSP)',
      value: 'mssp',
    },
    {
      id: 'software_platforms',
      isDisabled: false,
      label: 'Software & Platforms',
      value: 'software_platforms',
    },
    {
      id: 'hardware_electronics',
      isDisabled: false,
      label: 'Hardware & Electronics',
      value: 'hardware_electronics',
    },
    {
      id: 'cloud_providers',
      isDisabled: false,
      label: 'Cloud Providers',
      value: 'cloud_providers',
    },
    {
      id: 'media_broadcasting',
      isDisabled: false,
      label: 'Media & Broadcasting',
      value: 'media_broadcasting',
    },
  ],
  'Government & Public Sector': [
    {
      id: 'central_federal_government',
      isDisabled: false,
      label: 'Central / Federal Government',
      value: 'central_federal_government',
    },
    {
      id: 'local_government',
      isDisabled: false,
      label: 'Local Government',
      value: 'local_government',
    },
    {
      id: 'defence_military',
      isDisabled: false,
      label: 'Defence & Military',
      value: 'defence_military',
    },
    {
      id: 'law_enforcement_justice',
      isDisabled: false,
      label: 'Law Enforcement & Justice',
      value: 'law_enforcement_justice',
    },
    {
      id: 'emergency_services',
      isDisabled: false,
      label: 'Emergency Services',
      value: 'emergency_services',
    },
    {
      id: 'intelligence_security_agencies',
      isDisabled: false,
      label: 'Intelligence & Security Agencies',
      value: 'intelligence_security_agencies',
    },
  ],
  'Healthcare & Life Sciences': [
    {
      id: 'hospitals_clinics',
      isDisabled: false,
      label: 'Hospitals & Clinics',
      value: 'hospitals_clinics',
    },
    {
      id: 'pharmaceuticals',
      isDisabled: false,
      label: 'Pharmaceuticals',
      value: 'pharmaceuticals',
    },
    {
      id: 'biotechnology_research_labs',
      isDisabled: false,
      label: 'Biotechnology & Research Labs',
      value: 'biotechnology_research_labs',
    },
    {
      id: 'medical_devices',
      isDisabled: false,
      label: 'Medical Devices',
      value: 'medical_devices',
    },
    {
      id: 'health_insurance',
      isDisabled: false,
      label: 'Health Insurance',
      value: 'health_insurance',
    },
    {
      id: 'public_health_agencies',
      isDisabled: false,
      label: 'Public Health Agencies',
      value: 'public_health_agencies',
    },
  ],
  'Financial Services': [
    {
      id: 'retail_commercial_banking',
      isDisabled: false,
      label: 'Retail & Commercial Banking',
      value: 'retail_commercial_banking',
    },
    {
      id: 'insurance',
      isDisabled: false,
      label: 'Insurance',
      value: 'insurance',
    },
    {
      id: 'investment_banking_securities',
      isDisabled: false,
      label: 'Investment Banking & Securities',
      value: 'investment_banking_securities',
    },
    {
      id: 'asset_wealth_management',
      isDisabled: false,
      label: 'Asset & Wealth Management',
      value: 'asset_wealth_management',
    },
    {
      id: 'fintech_payments',
      isDisabled: false,
      label: 'FinTech & Payments',
      value: 'fintech_payments',
    },
    {
      id: 'trading_venues_brokers',
      isDisabled: false,
      label: 'Trading Venues & Brokers',
      value: 'trading_venues_brokers',
    },
  ],
  'Manufacturing & Industrial': [
    {
      id: 'aerospace_manufacturing',
      isDisabled: false,
      label: 'Aerospace Manufacturing',
      value: 'aerospace_manufacturing',
    },
    {
      id: 'defence_manufacturing',
      isDisabled: false,
      label: 'Defence Manufacturing',
      value: 'defence_manufacturing',
    },
    {
      id: 'automotive_transport_equipment',
      isDisabled: false,
      label: 'Automotive & Transport Equipment',
      value: 'automotive_transport_equipment',
    },
    {
      id: 'chemicals_plastics',
      isDisabled: false,
      label: 'Chemicals & Plastics',
      value: 'chemicals_plastics',
    },
    {
      id: 'metals_mining',
      isDisabled: false,
      label: 'Metals & Mining',
      value: 'metals_mining',
    },
    {
      id: 'industrial_machinery_robotics',
      isDisabled: false,
      label: 'Industrial Machinery & Robotics',
      value: 'industrial_machinery_robotics',
    },
    {
      id: 'electronics_manufacturing',
      isDisabled: false,
      label: 'Electronics Manufacturing',
      value: 'electronics_manufacturing',
    },
    {
      id: 'food_beverage_manufacturing',
      isDisabled: false,
      label: 'Food & Beverage Manufacturing',
      value: 'food_beverage_manufacturing',
    },
    {
      id: 'consumer_goods_apparel',
      isDisabled: false,
      label: 'Consumer Goods & Apparel',
      value: 'consumer_goods_apparel',
    },
  ],
  'Retail, Consumer & Hospitality': [
    {
      id: 'retail',
      isDisabled: false,
      label: 'Retail',
      value: 'retail',
    },
    {
      id: 'ecommerce',
      isDisabled: false,
      label: 'eCommerce',
      value: 'ecommerce',
    },
    {
      id: 'hospitality',
      isDisabled: false,
      label: 'Hospitality',
      value: 'hospitality',
    },
    {
      id: 'travel_tourism',
      isDisabled: false,
      label: 'Travel & Tourism',
      value: 'travel_tourism',
    },
    {
      id: 'entertainment_leisure',
      isDisabled: false,
      label: 'Entertainment & Leisure',
      value: 'entertainment_leisure',
    },
  ],
  'Education & Research': [
    {
      id: 'higher_education',
      isDisabled: false,
      label: 'Higher Education',
      value: 'higher_education',
    },
    {
      id: 'k12_education',
      isDisabled: false,
      label: 'K-12 Education',
      value: 'k12_education',
    },
    {
      id: 'research_institutes',
      isDisabled: false,
      label: 'Research Institutes',
      value: 'research_institutes',
    },
    {
      id: 'edtech',
      isDisabled: false,
      label: 'EdTech',
      value: 'edtech',
    },
  ],
  'Agriculture & Food Supply': [
    {
      id: 'farming_agriculture',
      isDisabled: false,
      label: 'Farming & Agriculture',
      value: 'farming_agriculture',
    },
    {
      id: 'food_processing_packaging',
      isDisabled: false,
      label: 'Food Processing & Packaging',
      value: 'food_processing_packaging',
    },
    {
      id: 'food_distribution_wholesale',
      isDisabled: false,
      label: 'Food Distribution & Wholesale',
      value: 'food_distribution_wholesale',
    },
  ],
  'Real Estate & Construction': [
    {
      id: 'commercial_real_estate',
      isDisabled: false,
      label: 'Commercial Real Estate',
      value: 'commercial_real_estate',
    },
    {
      id: 'residential_real_estate',
      isDisabled: false,
      label: 'Residential Real Estate',
      value: 'residential_real_estate',
    },
    {
      id: 'construction_infrastructure',
      isDisabled: false,
      label: 'Construction & Infrastructure',
      value: 'construction_infrastructure',
    },
  ],
  'Nonprofits & International Orgs': [
    {
      id: 'charities_ngos',
      isDisabled: false,
      label: 'Charities & NGOs',
      value: 'charities_ngos',
    },
    {
      id: 'foundations',
      isDisabled: false,
      label: 'Foundations',
      value: 'foundations',
    },
    {
      id: 'international_organisations',
      isDisabled: false,
      label: 'International Organisations',
      value: 'international_organisations',
    },
    {
      id: 'religious_organisations',
      isDisabled: false,
      label: 'Religious Organisations',
      value: 'religious_organisations',
    },
  ],
};

export const TTX_SCENARIO_PARTICIPATING_ROLES = [
  'SOC Analyst',
  'Incident Responder',
  'Threat Hunter',
  'Digital Forensic Analyst',
  'Malware Analyst',
  'SOC Manager',
  'IR Manager',
  'Crisis Manager',
  'CISO',
  'Network Engineer',
  'Endpoint Administrator',
  'Cloud Security Engineer',
  'Identity & Access Administrator',
] as const;

export const TTX_SCENARIO_PHASES = [
  'PreIncident',
  'Detection',
  'Analysis',
  'Containment',
  'Eradication',
  'Recovery',
  'PostIncident',
] as const;

export const TTX_SCENARIO_ATTACK_TYPES = [
  'Data exfiltration',
  'Insider threat',
  'Ransomware',
  'Malware',
  'Espionage',
  'Extortion',
  'Identity theft',
  'Sabotage',
  'Financial fraud',
  'Supply chain attack',
  'Credential theft',
] as const;

export const TTX_SCENARIO_OBJECTIVES_OPTIONS = [
  {
    id: '1',
    isDisabled: false,
    label: 'Test and Validate Incident Response Plans and Procedures',
    value: 'test_and_validate_incident_response',
  },
  {
    id: '2',
    isDisabled: false,
    label: 'Enhance Team Coordination and Communication',
    value: 'enhance_team_coordination',
  },
  {
    id: '3',
    isDisabled: false,
    label: 'Identify and Address Gaps in Security Policies and Procedures',
    value: 'identify_and_address_gaps',
  },
  {
    id: '4',
    isDisabled: false,
    label: 'Increase Organizational Awareness and Preparedness',
    value: 'increase_organizational_awareness',
  },
  {
    id: '5',
    isDisabled: false,
    label: 'Fulfill Regulatory Compliance and Audit Requirements',
    value: 'fulfill_regulatory_compliance',
  },
];

export const TTX_SCENARIO_INCIDENT_RESPONSE_FRAMEWORKS = ['NIST', 'ISO 27035'] as const;

export const TTX_SCENARIO_ARCHITECTURE_OPTIONS = [
  {
    id: 'on-premises',
    isDisabled: false,
    label: 'On-premises',
    value: 'on-premises',
  },
  {
    id: 'single-cloud',
    isDisabled: false,
    label: 'Single-Cloud',
    value: 'single-cloud',
  },
  {
    id: 'multi-cloud',
    isDisabled: false,
    label: 'Multi-Cloud',
    value: 'multi-cloud',
  },
  {
    id: 'hybrid',
    isDisabled: false,
    label: 'Hybrid',
    value: 'hybrid',
  },
];

export const TTX_SCENARIO_APPLICATION_OPTIONS = {
  'Security & Monitoring': [
    {
      id: 'siem',
      isDisabled: false,
      label: 'SIEM',
      value: 'siem',
    },
    {
      id: 'edr',
      isDisabled: false,
      label: 'EDR',
      value: 'edr',
    },
    {
      id: 'vpn',
      isDisabled: false,
      label: 'VPN',
      value: 'vpn',
    },
    {
      id: 'firewalls',
      isDisabled: false,
      label: 'Firewalls',
      value: 'firewalls',
    },
  ],
  'User and Business Applications': [
    {
      id: 'email_platform',
      isDisabled: false,
      label: 'Email Platform',
      value: 'email_platform',
    },
    {
      id: 'web_apps',
      isDisabled: false,
      label: 'Web Apps',
      value: 'web_apps',
    },
    {
      id: 'mobile_apps',
      isDisabled: false,
      label: 'Mobile Apps',
      value: 'mobile_apps',
    },
    {
      id: 'communication_tool',
      isDisabled: false,
      label: 'Communication tools (e.g. Microsoft Teams, Slack)',
      value: 'communication_tool',
    },
    {
      id: 'cloud_storage',
      isDisabled: false,
      label: 'Cloud storage',
      value: 'cloud_storage',
    },
  ],
  Infrastructure: [
    {
      id: 'active_directory',
      isDisabled: false,
      label: 'Active Directory',
      value: 'active_directory',
    },
    {
      id: 'rdp',
      isDisabled: false,
      label: 'Remote management tools (RDP)',
      value: 'rdp',
    },
    {
      id: 'sccm',
      isDisabled: false,
      label: 'Configuration Management (SCCM)',
      value: 'sccm',
    },
    {
      id: 'visualisation_platform',
      isDisabled: false,
      label: 'Visualisation platform',
      value: 'visualisation_platform',
    },
  ],
};

export const TTX_SCENARIO_OPERATING_SYSTEMS = ['windows', 'mac', 'linux'] as const;

export interface RegenerateDetails {
  title: string;
  text: string;
  subText: string;
  ctaLabel: string;
}

export enum Stages {
  INITIAL_ACCESS = 'Initial Access',
  LATERAL_MOVEMENT = 'Lateral movement & Privilege Escalation',
  GOAL_EXECUTION = 'Goal Execution',
}

export enum Phases {
  TRIAGE = 'Triage',
  DETECTION_INVESTIGATION = 'Detection & Investigation',
  CONTAINMENT_ERADICATION = 'Containment & Eradication',
  RECOVERY = 'Recovery',
  ESCALATION = 'Escalation',
}

export const StagesMap = {
  1: Stages.INITIAL_ACCESS,
  2: Stages.LATERAL_MOVEMENT,
  3: Stages.GOAL_EXECUTION,
};

export const PhasesMap = {
  1: Phases.TRIAGE,
  2: Phases.DETECTION_INVESTIGATION,
  3: Phases.CONTAINMENT_ERADICATION,
  4: Phases.RECOVERY,
  5: Phases.ESCALATION,
};

export const PhaseTooltip: Record<(typeof Phases)[keyof typeof Phases], string> = {
  [Phases.TRIAGE]:
    "Triage phase focuses on establishing the current incident level, and determining the policies, procedures, plans and resources required based on what you know about the attacker's actions so far",
  [Phases.DETECTION_INVESTIGATION]:
    'Detection and Investigation phase focuses on how you would detect and analyze the nature and scope of the incident so far.',
  [Phases.CONTAINMENT_ERADICATION]:
    'During the Containment and Eradication phase, your actions should focus on isolating the incident to prevent further damage and eliminating or delaying the attack where possible.',
  [Phases.RECOVERY]: 'In the Recovery phase, you must attempt to restore effected systems to normal operation.',
  [Phases.ESCALATION]:
    'In this final phase of the IR lifecycle, you should determine if the incident needs to be escalated further at this stage based on the current threat and indicators of compromise.',
};

export interface TTXStageConfiguration {
  isLastStagePhase: boolean;
  isLastStage: boolean;
}

export interface TTXExerciseConfiguration {
  stages: Record<number, TTXStageConfiguration>;
  totalSteps: number;
  stageStartingSteps: number[];
  totalStages?: number;
  stepsPerStage?: number[];
  stagePhases: Record<number, number[]>;
  stepToPhaseMap: Record<number, number>;
}

export const TTX_SCENARIO_SETUP_OPTIONS = {
  QUICK: 'quick',
  FULL: 'full',
} as const;

export type TTXScenarioSetupOptions = (typeof TTX_SCENARIO_SETUP_OPTIONS)[keyof typeof TTX_SCENARIO_SETUP_OPTIONS];

export * from './ttx-assistants';
export * from './ttx-dashboard';
export * from './ttx-open-router';
export * from './ttx-phases';
export * from './ttx-stages';
export * from './ttx-state';
export * from './ttx-templates';
